import RegisterField, { FieldProps } from "../register-field";
import { ImageField, ImageFieldProps } from "@/components/inputs";

export default function FormImageField({
    name,
    registerOptions,
    ...props
}: FieldProps<ImageFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <ImageField
            {...props}
            
            value={field.value}
            disabled={field.disabled}

            onChange={(e, v) => {
                field.handleChange(v);
                props.onChange && props.onChange(e, v);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}
        />}
    </RegisterField>
}